import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { normalizeSocialLink as n } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as m } from "../../utils/get-social-link-icon.mjs";
import s from "../../../components/store-image.mjs";
import { useStore as i } from "../../../store/index.mjs";
import { StoreImageEnum as d } from "../../../enums/store-image-enum.mjs";
const u = ({ profile: e, socialLinks: l }) => {
  const { locale: a } = i();
  return /* @__PURE__ */ o(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[500px] w-full flex-col items-center justify-end gap-5 overflow-hidden rounded-none bg-cover bg-center px-10 pb-10 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ t(
          s,
          {
            width: 500,
            height: 500,
            alt: e.sellerName,
            imageType: d.profile,
            className: "-z-1 absolute top-0 w-full "
          }
        ),
        /* @__PURE__ */ o("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ t(
            "h1",
            {
              id: "region-heading",
              lang: a,
              className: "text-THEME-primary break-all text-center text-[40px] font-bold leading-[50px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ t(
            "span",
            {
              lang: a,
              className: "hyphens-auto text-center text-lg font-normal text-[#FAFAFA]",
              children: e.bio
            }
          )
        ] }),
        !!l.length && /* @__PURE__ */ t("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: l.map((r) => /* @__PURE__ */ t(
          "a",
          {
            href: n(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-1",
            "aria-label": r.type,
            children: m(r.type, "fill-THEME-text-secondary")
          },
          r.type
        )) }),
        /* @__PURE__ */ t(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-[300px] w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
};
export {
  u as ProfileCamilla
};
